export default __webpack_public_path__ + "15b4e1a35bf44c04a438c25338c13fcc.png";